import { createSlice } from '@reduxjs/toolkit'

export const mainSearchTextboxSlice = createSlice({
    name: 'mainSearchTextbox',
    initialState: {
        isOpen: false,
    },
    reducers: {
        open: (state) => {
            state.isOpen = true
        },
        close: (state) => {
            state.isOpen = false
        },
        toggle: (state) => {
            state.isOpen = !state.isOpen
        }
    }
})

export const { open, close, toggle } = mainSearchTextboxSlice.actions;
export default mainSearchTextboxSlice.reducer
